import React from "react";
import Image from "react-bootstrap/Image";
import Media from "react-media";
import { ReusableOnboardingButton } from "../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import RightSidePannel from "../rightSidePannelReusable/RightSidePannel";

export const MainSubscriptionHome = ({
  onClick,
  backButton,
  backButtonMobile,
}) => {
  return (
    <React.Fragment>
      <div className="bank_and_other_details_onboarding_main">
        <div
          id="onboarding-scrollbar"
          className="bank_and_other_details_onboarding_homescreen enOnBoardingForm text-left"
        >
          <div>
            {/* <div className="display-toggle-stepup-button">
              <RightSidePannel selectedTab={4} />
            </div> */}
            {/* <h3 className="bank_and_other_details_onboarding-heading-text-big">
              Subscription and Other Settings
            </h3>
            <hr /> */}
            <div className="f24_700_HelveticaNeue pb-5">Subscription</div>
            {/* <Image
            className="image-subscriptions-home"
            src={require("../../../../assets/images/onboarding/storeSetup6.png")}
            alt="bank"
            title="bank"
            fluid
          /> */}
            <div
              id="style-4"
              style={{ height: "52vh", maxWidth: 500, overflowY: "auto" }}
            >
              <div className="f18-700 mb-3">Key Points</div>
              <p className="f12-400 opacity5 pb-3">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry’s standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book.
              </p>
              <p className="f12-400 opacity5 pb-3">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry’s standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book.
              </p>
            </div>
          </div>
          <div className="onboarding-map-setup-screen-autodetect-button mt-5">
            {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
            <Media query="(min-width: 992px)">
              <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                buttonText="Back"
                onClick={backButton}
              />
            </Media>
            <Media query="(max-width: 991px)">
              <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                buttonText="Back"
                onClick={backButtonMobile}
              />
            </Media>

            <ReusableOnboardingButton
              buttonTitle="Next Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
              buttonText="Next"
              onClick={onClick}
            />
            {/* </div> */}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
//update 16-06-20
